import React, { useLayoutEffect, useRef } from 'react'

const DecimalComponent = React.memo(
  ({ focus, active, rowData, setRowData }) => {
    const ref = useRef(null)
    const displayValue = useRef(rowData?.toString() ?? "")

    useLayoutEffect(() => {
      if (focus) {
        ref.current?.focus()
      } else {
        ref.current?.blur()
      }
    }, [focus])

    return (
      <input
        className="w-full h-full border-none bg-transparent"
        type="text"
        inputMode='decimal'
        required
        tabIndex={-1}
        ref={ref}
        style={{
          pointerEvents: focus ? 'auto' : 'none',
          opacity: rowData || active ? undefined : 0,
        }}
        value={displayValue.current}
        onChange={(e) => {
          const value = e.target.value
          displayValue.current = value
          
          // Allow the user to type freely, including decimals
          // Only update rowData if it's a valid number or empty
          if (!value.trim()) {
            setRowData(null)
          } else {
            const num = parseFloat(value)
            if (!isNaN(num)) {
              setRowData(num)
            }
          }
        }}
        onBlur={() => {
          // On blur, clean up the display value to match the parsed number
          const num = parseFloat(displayValue.current)
          if (!isNaN(num)) {
            displayValue.current = num.toString()
            setRowData(num)
          } else {
            displayValue.current = rowData?.toString() ?? ""
          }
        }}
      />
    )
  }
)

DecimalComponent.displayName = 'DecimalComponent'

export const decimalColumn = {
  component: DecimalComponent,
  deleteValue: () => null,
  copyValue: ({ rowData }) => rowData,
  pasteValue: ({ value }) => {
    const num = parseFloat(value)
    return isNaN(num) ? null : num
  },
  minWidth: 170,
  isCellEmpty: ({ rowData }) => !rowData,
}
